import { useEffect, useState } from "react";
import {
  Box, Card, Chip, Pagination, Stack, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Typography,
} from "@mui/material";
import { auditApi } from "../api/resources";
import { useLanguage } from "../i18n/LanguageContext";
import { COLORS } from "../theme";

export default function AccesosPage() {
  const { t, lang } = useLanguage();
  const [data, setData] = useState({ items: [], page: 1, totalPages: 1, total: 0 });
  const [page, setPage] = useState(1);

  useEffect(() => {
    auditApi.listLogins(page, 20).then(setData);
  }, [page]);

  const fmt = (iso) =>
    new Date(iso).toLocaleString(lang === "en" ? "en-US" : "es-MX", {
      day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
    });

  return (
    <Box>
      <Typography variant="h5">{t("accesos.title")}</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {t("accesos.subtitle")}
      </Typography>

      <TableContainer component={Card}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: "#F4F5EF" }}>
              <TableCell>{t("accesos.colDate")}</TableCell>
              <TableCell>{t("accesos.colUser")}</TableCell>
              <TableCell>{t("accesos.colRole")}</TableCell>
              <TableCell>{t("accesos.colResult")}</TableCell>
              <TableCell>{t("accesos.colIp")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.items.map((log) => (
              <TableRow key={log._id} hover>
                <TableCell>
                  <Typography variant="caption" color="text.secondary">{fmt(log.createdAt)}</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">{log.name || log.username}</Typography>
                  <Typography variant="caption" color="text.secondary">{log.username}</Typography>
                </TableCell>
                <TableCell>{log.role && <Chip size="small" label={t(`layout.role_${log.role}`)} />}</TableCell>
                <TableCell>
                  <Chip
                    size="small"
                    label={log.success ? t("accesos.success") : t("accesos.failed")}
                    sx={{
                      bgcolor: log.success ? COLORS.greenSoft : COLORS.rustSoft,
                      color: log.success ? COLORS.green : COLORS.rust,
                    }}
                  />
                  {!log.success && log.reason && (
                    <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.3 }}>
                      {log.reason}
                    </Typography>
                  )}
                </TableCell>
                <TableCell>
                  <Typography variant="caption" color="text.secondary">{log.ip}</Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {data.totalPages > 1 && (
        <Stack alignItems="center" sx={{ mt: 2 }}>
          <Pagination count={data.totalPages} page={page} onChange={(_, v) => setPage(v)} size="small" />
        </Stack>
      )}
    </Box>
  );
}
